var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ml-auto d-flex align-center"},[_c('QueryCnfGearBtn'),_c('MinMaxBtnCtr')],1)
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }